"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelperText = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useScaleDensity = require("@cbhq/cds-common/scale/useScaleDensity");
var _icons = require("../icons");
var _layout = require("../layout");
var _typography = require("../typography");
const _excluded = ["color", "errorIconAccessibilityLabel", "errorIconTestID", "children", "dangerouslySetColor"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const HelperText = /*#__PURE__*/(0, _react.memo)(function HelperText(_ref) {
  let color = _ref.color,
    errorIconAccessibilityLabel = _ref.errorIconAccessibilityLabel,
    errorIconTestID = _ref.errorIconTestID,
    children = _ref.children,
    dangerouslySetColor = _ref.dangerouslySetColor,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const density = (0, _useScaleDensity.useScaleDensity)();
  const TextComponent = (0, _react.useMemo)(() => density === 'dense' ? _typography.TextBody : _typography.TextLabel2, [density]);
  return /*#__PURE__*/_react.default.createElement(TextComponent, _extends({
    as: "span",
    color: color,
    dangerouslySetColor: dangerouslySetColor,
    display: "block"
  }, props), color === 'negative' && /*#__PURE__*/_react.default.createElement(_layout.Box, {
    as: "span",
    display: "inline-block",
    spacingEnd: 0.5
  }, /*#__PURE__*/_react.default.createElement(_icons.Icon, {
    accessibilityLabel: errorIconAccessibilityLabel,
    color: "negative",
    dangerouslySetColor: dangerouslySetColor,
    name: "info",
    size: "xs",
    testID: errorIconTestID
  })), children);
});
exports.HelperText = HelperText;